module.exports = __webpack_public_path__ + "static/media/ph.5458079e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ph.png
// module id = 1955
// module chunks = 0